import { isLotExpired, LOT_STATUS } from '../../utils/lotSystem';

export const EXPIRED_PROCESSING_DEBOUNCE_MS = 1000;
export const EXPIRED_LOT_CHANGE_DEBOUNCE_MS = 2000;

/** True when at least one lot is past expiry with remaining stock (needs sweep). */
export function lotsHaveExpiredStock(lots) {
  if (!Array.isArray(lots) || lots.length === 0) return false;

  return lots.some((lot) => {
    if (!lot?.expirationDate) return false;
    if (lot.status === LOT_STATUS.EXPIRED) return false;
    if (Number(lot.remainingQuantity) <= 0) return false;
    return isLotExpired(lot);
  });
}

/** Stable signature for expired-product display rows (skip redundant setState). */
export function expiredDisplaySignature(rows) {
  if (!Array.isArray(rows)) return '';
  return rows
    .map((r) => `${r.lotId || r.id}:${r.quantity}:${r.status}`)
    .sort()
    .join('|');
}
